module.exports = __webpack_public_path__ + "static/img/qsc(1).0290a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/qsc(1).png
// module id = ZPq8
// module chunks = 1